import { gql } from 'graphql-tag'

export const GET_ADDRESS_FROM_GEOCODE = gql`
  query getAddressFromGeocode($lat: Float!, $lng: Float!, $consumerId: String!) {
    getAddressFromGeocode(lat: $lat, lng: $lng, consumerId: $consumerId) {
      street
      city
      state
      zipCode
      country
      location {
        lat
        lng
      }
    }
  }
`
